import Image from 'next/image'
import { FC } from 'react'

import { ScreenSize, SOMETHING_WENT_WRONG } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'

import EmptyListPlug from './EmptyListPlug'

type ErrorCard = {
  title?: string
  customDescription?: string
}

export const ErrorCard: FC<ErrorCard> = ({ title, customDescription }) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  return (
    <div className="flex flex-col items-center justify-center">
      <EmptyListPlug
        image={
          <Image
            src="/images/shared/something-went-wrong.png"
            alt="image"
            className="rotate-12"
            width={isMobileScreen ? '80' : '120'}
            height={isMobileScreen ? '80' : '120'}
          />
        }
        title={SOMETHING_WENT_WRONG}
        description={
          <div className="flex flex-col">
            {title && <span className="whitespace-pre-line">{title}</span>}
            {customDescription && <span>{customDescription}</span>}
            {!title && !customDescription && (
              <>
                <span>Мы уже работаем над проблемой.</span>
                <span>Приносим извинения за неудобства</span>
              </>
            )}
          </div>
        }
        className="!mt-0"
        titleClassName="text-24 sm:text-20"
        descriptionClassName="!text-grey-60 text-20 sm:text-14 max-w-[330px] sm:max-w-[260px]"
      />
    </div>
  )
}
